import { Button } from '@mui/material';
import SingleLineTextWidget from 'app/common/components/widgets/single-line-text';
import Form from 'app/schema-form/components/schema-form';
import { fromJS } from 'immutable';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { CREATE_PUBLISH_TARGET_FORM_NAME } from '../../constants';

const publishTargetSchema = fromJS({
  netlify: {
    title: 'Create New Site',
    type: 'object',
    properties: {
      name: {
        title: 'Site Name',
        type: 'string'
      },
      password: {
        title: 'Password',
        type: 'string'
      }
    }
  },
  vercel: {
    title: 'Create New Project',
    type: 'object',
    properties: {
      name: {
        title: 'Project Name',
        type: 'string'
      }
    },
    required: ['name']
  }
});

const publishTargetConfig = fromJS({
  netlify: {
    order: ['name', 'password'],
    properties: {
      name: {
        widget: 'singleLineText',
        instructions: 'Netlify Site Name (Optional, must be globally unique)'
      },
      password: {
        widget: 'singleLineText',
        instructions: 'Password protect your Netlify site (Optional)'
      }
    }
  },
  vercel: {
    order: ['name'],
    properties: {
      name: {
        widget: 'singleLineText',
        instructions: 'Vercel Project Name'
      }
    }
  }
});

const widgets = {
  singleLineText: SingleLineTextWidget
};

export default class CreatePublishTarget extends Component {
  static propTypes = {
    provider: PropTypes.string.isRequired,
    createPublishTarget: PropTypes.func.isRequired,
    submitForm: PropTypes.func.isRequired,
    targetFormName: PropTypes.string.isRequired,
    targetFormPath: PropTypes.string.isRequired
  };

  handleSubmit = () =>
    this.props.submitForm(CREATE_PUBLISH_TARGET_FORM_NAME, ({ data }) =>
      this.props.createPublishTarget({
        ...data,
        provider: this.props.provider,
        target: {
          formName: this.props.targetFormName,
          path: this.props.targetFormPath
        }
      })
    );

  render() {
    const { provider } = this.props;
    return (
      <div>
        <Form
          formName={CREATE_PUBLISH_TARGET_FORM_NAME}
          schema={publishTargetSchema.get(provider)}
          config={publishTargetConfig.get(provider)}
          widgets={widgets}
        />
        <Button raised onClick={this.handleSubmit}>
          Create
        </Button>
      </div>
    );
  }
}
